import {Component, inject, OnInit, signal} from '@angular/core'
import {MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle} from '@angular/material/dialog'
import {MatButton} from '@angular/material/button'
import {HttpClient, HttpContext} from '@angular/common/http'
import {email, Field, form, minLength, required} from '@angular/forms/signals'
import {GITLAB_ACCESS_TOKEN} from '../../application/auth-interceptor'
import {MatFormField, MatHint, MatInput, MatLabel} from '@angular/material/input'
import {DateTime} from 'luxon'
import {MatOption, MatSelect} from '@angular/material/select'
import {WaitComponent} from '@sparbanken-syd/sparbanken-syd-theme'
import {GITLAB_HOST, GitlabService} from '../../services/gitlab.service'
import {AuthComponent} from '../auth/auth.component'
import {tap} from 'rxjs'
import {filter} from 'rxjs/operators'


interface IVariables {
  groupId: string
  email: string
  token: string
}

@Component({
  selector: 'spb-docker-auth',
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButton,
    MatFormField,
    MatLabel,
    MatInput,
    Field,
    MatSelect,
    MatOption,
    MatHint,
    MatDialogClose
  ],
  templateUrl: './docker-auth.component.html',
  styleUrl: './docker-auth.component.scss'
})
export class DockerAuthComponent implements OnInit {

  /**
   * Should be private ...
   */
  public model = signal<IVariables>({
    // Sparbanken Syd
    groupId: '5335894',
    email: '',
    token: ''
  })
  public form = form(this.model, path => {
    required(path.email)
    email(path.email)
    required(path.token)
    minLength(path.token, 20)
  })
  private http = inject(HttpClient)

  private readonly service = inject(GitlabService)

  private readonly context = new HttpContext()

  private readonly dialog = inject(MatDialog)

  public ngOnInit() {
    this.service.gitLabAccessToken()
      .pipe(
        tap(token => {
          if (token === null) {
            this.dialog.open(AuthComponent, {disableClose: true})
          }
        }),
        filter(Boolean)
      )
      .subscribe(token => this.context.set(GITLAB_ACCESS_TOKEN, token))
  }

  public generateToken() {
    const value = JSON.stringify({
      auths: {
        'registry.gitlab.com': {
          auth: window.btoa(`${this.model().email}:${this.model().token}`)
        }
      }
    }, null, 2)
    const req = {
      key: 'DOCKER_AUTH_CONFIG',
      description: `Yet another shitty docker thing FTW ${DateTime.now().toFormat('yyyy-MM-dd')}`,
      masked: false,
      protected: false,
      value
    }

    const url = `${GITLAB_HOST}/groups/${this.model().groupId}/variables/DOCKER_AUTH_CONFIG`
    this.http.put(url, req, {context: this.context}).subscribe(() => {
      this.dialog.open(WaitComponent, {
        data: {
          title: 'Klart',
          text: 'Variabeln är uppdaterad.',
          closable: true
        }
      })
    })
  }

}
